<template>
  <div id="app">
    <transition name="show-from-left">
        <popover name="helpfail" :width="240">
            <Help :titleChart="titleChart">
            <div slot="content">
              <p> {{ $t("263") }}</p>
              <p>
                <ul>
                  <li><b>{{ $t("264") }}:</b> {{ $t("265") }}</li>
                  <li><b>{{ $t("266") }}:</b> {{ $t("267") }}</li>
                  <li><b>{{ $t("268") }}:</b> {{ $t("269") }}</li>
                  <li><b>{{ $t("270") }}:</b> {{ $t("271") }}</li>
                  <li><b>{{ $t("272") }}:</b> {{ $t("273") }}</li>
                  <li><b>{{ $t("274") }}:</b> {{ $t("275") }}</li>
                </ul>
            </p>
            </div>
          </Help>
        </popover>
    </transition>

    <div class="title-charts title-bt-help title-margin">{{ $t("276") }}
      <button class="bt-help" v-popover:helpfail.bottom><i class="icon-help ti-help-alt"></i></button>
    </div>

    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script src="https://code.highcharts.com/modules/heatmap.js"></script>
<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'

export default {
  name: 'charts',
  components: {
    Help
  },
  data () {
    return {
      titleChart: this.$t("276"),
      tableData: [],
      chartOptions: {
        //colors: ['#2fb62f', '#f8ff00', '#f8ff00', '#f56b00', '#fe0000', '#fe0000'],
        //colors: ['#2fb62f', '#f8ff00',],
        chart: {
          type: 'heatmap',
          backgroundColor: 'rgba(0,0,0,0)',
          marginTop: 40,
          // marginBottom: 80,
          plotBorderWidth: 1,
          height: 520
        },

        title: {
            text: ''
        },

        xAxis: {
            // categories: ['<= 3', '> 3', '> 7', '> 15', '> 30', '> 60']
            categories: [],
            title:{
              text: 'days',
              style: {
                color: '#fff'
              }
            }
        },

        yAxis: {
            // categories: ['JC', 'Not Installed', 'Dieded', 'Broked', 'Out of machine', 'Battery dieded', 'Gateway', 'Not Appointed'],
            categories: [],
            title: null,
            reversed: true,
        },

        tooltip: {
            formatter: function() {
              let value = this.point.value
              if (value || value == 0){
                return '<b>' + this.point.value + '</b> sensors - <b>' + this.series.yAxis.categories[this.point.y] + '</b>';
              }
              return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>No data!</b>'
            },
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
              color: '#F0F0F0'
            },
        },

        series: [{
          borderWidth: 1,
          data: [],
          showInLegend: false,
          dataLabels: {
            enabled: true,
            color: '#000000'
          }
        }],

        plotOptions: {
          heatmap: {
            nullColor: '#000',
            borderColor: '#000'
          },
          series:{
            dataLabels:{
              formatter:function() {
                return '<span style="font-size:14px" >' +  this.point.value + '</span>';
              }
            },
            events:{
              click: this.loadGrid
            },
            cursor: 'pointer',
          }
        },

        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },

        exporting: { enabled: false },
        credits: {
          enabled: false
        },

      },//fim chartOptions
    }
  },
  methods: {
    ...mapMutations(['changeGridOnline']),
    getData(){
        const API = process.env.ROOT_API;

        let param = {
          'corp': this.filtersOn.corp,
          'region': this.filtersOn.region,
          'planta': this.filtersOn.planta,
          'area_f': this.filtersOn.area_f,
          'sector_f': this.filtersOn.sector_f,
          'machine': this.filtersOn.machine,
          'subset': this.filtersOn.subset,
        }

        this.$refs.chart.chart.showLoading();

        let self = this;
        axios({method: 'GET', url: API + 'v1/mysemeq-ambev/get-sensors-failure-mode', params: param, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function({ data }){
                if (data){

                  // let colors = ['#f8ff00', '#ffc300', '#f56b00', '#fe0000']

                  let colors = ['#e4d354', '#ffc300', '#f0893a', '#f45b5b']


                  if (data[0].length == 0){
                    self.$refs.chart.chart.showLoading('No data');
                    return false;
                  }

                  let points = data[0].map( elem => {
                    elem['color'] = colors[elem.x]
                    return elem
                  })

                  self.chartOptions.series[0].data = points;
                  self.chartOptions.xAxis.categories = data[1];

                  data[2][0] = (self.filtersOn.planta_name == 'All' ? '' : self.filtersOn.planta_name) || self.filtersOn.region || 'ABInBev'; // Nome da planta/região na primeira posicao do Y
                  self.chartOptions.yAxis.categories = data[2];

                }
            })
            .catch(function(error){
              self.$refs.chart.chart.showLoading('Error');

              // from mixin
              self.ApiErrorHandler(self, error.response.data.status_code);
            })

    },
    loadGrid(event){

      let area_title = this.chartOptions.yAxis.categories[event.point.y].split(' ').filter(item => { return item != '-'}).join('_');
      let motivo = event.point.y != 0 ? this.chartOptions.yAxis.categories[event.point.y] : '';
      let status = event.point.x;
      let point_name = area_title
      let NAME_CHART = this.$t("372") + ' - ' + point_name.toUpperCase()
      const ENDPOINT = `v1/mysemeq-ambev/get-sensors-failure-mode-grid?corp=${this.filtersOn.corp}&region=${this.filtersOn.region}&planta=${this.filtersOn.planta}&motivo=${motivo}&status=${status}&area_f=${this.filtersOn.area_f}&sector_f=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&subset=${this.filtersOn.subset}`

      let gridOnline = {
        title: this.$t("372") + ' - ' + this.chartOptions.yAxis.categories[event.point.y],
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "area": [this.$t("311")],
          "setor": [this.$t("312")],
          "conj": [this.$t("316"), 'conjunto'],
          "conj_tag": [this.$t("317")],
          "equip": [this.$t("313")],
          "equip_tag": [this.$t("314")],
          "serie": [this.$t("339")],
          "versao": [this.$t("336")],
          "data": [this.$t("334")],
          "bateria": [this.$t("335")],
          "sinal_nivel": [this.$t("337")],
          "node": [this.$t("338"), 'nodo'],
          "status": ['Status'],
          "id_planta": ['id_planta'],
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("372"),
        txtHelp: this.$t("373") 
      }

      if (!this.filtersOn.planta) {
        gridOnline.columns = {"rows": [''], 'planta': [this.$t("310"), 'planta_f'], ...gridOnline.columns}
      }
      else{
        gridOnline.columns = {"rows": [''],  ...gridOnline.columns}
      }

      if (event.point.value) { this.changeGridOnline(gridOnline) }

    },
  },
  computed: {
    ...mapGetters(['filtersOn']),
  },
  watch: {
    filtersOn: function(newValue){
     this.getData();
    },
  }
}
</script>
<style >
.highcharts-title tspan {
    fill: #fff;
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    color: #fff;
    font-weight: normal;
    font-size: 14px;
}
.highcharts-axis-labels tspan {
    fill: #fff;
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    color: #fff;
    font-weight: normal;
    font-size: 10px;
}
.highcharts-axis-labels text tspan {
  color: #fff!important;
  fill: #fff!important;
}
.highcharts-axis-labels text{
  color: #fff!important;
  fill: #fff!important;
}
.highcharts-text-outline {
  fill: none!important;
  stroke: none!important;
  color: #000;
}

div[data-popover="helpfail"] {
  left: 40% !important;
  top:5%!important;
}

.title-margin{
  margin-bottom: -20px;
  position: absolute;
  top: 0px;
  right: 33%;
  z-index: 99999;
}


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/HeatMapSensorAppointments.vue